import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const KeyIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
		<path
			fill="#F90"
			fillRule="evenodd"
			d="M20 6.293c0 3.476-2.83 6.294-6.32 6.294-.636 0-2.086-.146-2.791-.732l-.882.878c-.519.517-.379.669-.148.919.096.105.208.226.295.399 0 0 .735 1.024 0 2.049-.441.585-1.676 1.404-3.086 0l-.294.292s.881 1.025.147 2.05c-.441.585-1.617 1.17-2.646.146l-1.028 1.024c-.706.703-1.568.293-1.91 0l-.883-.878c-.823-.82-.343-1.708 0-2.05l7.642-7.61s-.735-1.17-.735-2.78c0-3.476 2.83-6.294 6.32-6.294S20 2.818 20 6.293Z"
			clipRule="evenodd"
			opacity=".3"
		/>
		<path
			fill="#F90"
			d="M15.885 6.294a2.2 2.2 0 0 1-2.204 2.195 2.2 2.2 0 0 1-2.204-2.195 2.2 2.2 0 0 1 2.204-2.196 2.2 2.2 0 0 1 2.204 2.196Z"
		/>
	</svg>
);
